<template>
  <div class="container">
    <van-popup v-model="show" >
      <label class="titlegn">功能介绍:</label>
      <label class="contentgn">“备份Wi-Fi”这个功能可以把备份Wi-Fi的信息同步到日历上。当日历无法连接上次连接的Wi-Fi时，日历会尝试连接备份的Wi-Fi。只有两个Wi-Fi都连不上的时候才提示“联网失败”。</label>
      <label class="titlecj">典型应用场景:</label>
      <label class="contentcj">您在家里给日历配好了Wi-Fi，需要把日历带到一个无Wi-Fi的环境或即使有Wi-Fi但个人设备无法接入的环境中使用。</label>
      <label class="contentcjs">您灵机一动可以用手机/电脑的热点啊。但是怎么把热点配置到日历上呢？</label>
      <label class="contentcjs">通常的方式是您的手机连上热点然后使用公众号里的“更改/设置Wi-Fi”进行Wi-Fi配置。</label>
      <label class="contentcjs">使用“配置备份Wi-Fi”这个功能您无需更改当前Wi-Fi设置，可以直接把备用的Wi-Fi加到日历里。</label>
      <label class="titletip">请注意：使用此功能需要您的日历当前能联网</label>
      <button class="btnknow"  @click="closePopup">知道了</button>
    </van-popup>
    <div class="item">
      <label>备份Wi-Fi帐号</label>
      <cube-input placeholder="请输入您的备份Wi-Fi帐号" v-model="hotName" :clearable="clearable"></cube-input>
    </div>
    <div class="item">
      <label>备份Wi-Fi密码</label>
      <cube-input placeholder="请输入您的备份Wi-Fi密码" v-model="hotPass" :eye="eye" ></cube-input>
    </div>
    <button class="btnsave"  @click="save">保存</button>
    <button class="bfbtn" @click="showPopup">什么是备份Wi-Fi？</button>
    <setting-internet v-if="showTip" @next="nextUpdate" @now="nowUpdate"></setting-internet>
  </div>
</template>
<script>
import Common from '../../assets/js/common.js'
import axios from 'axios'
import { Popup } from 'vant'
import {mapState, mapMutations} from 'vuex'
import SettingInternet from '../../components/SettingInternet/SettingInternet.vue'


var api = process.env.BASE_URL
var isLocal = Common.getEvn()
export default {
  components: {
    [Popup.name]: Popup,
    SettingInternet
  },
  data () {
    return {
      show: false,
      clearable: true,
      eye: {
        open: true,
        reverse: false
      },
      showTip: false,
      quit: false,
      hotName: localStorage.getItem('max_hot_name'),
      hotPass: localStorage.getItem('max_hot_pass'),
      deviceId: localStorage.getItem('max_device_id')
    }
  },
  
  methods: {
    nextUpdate () {
      // this.settingWater()
      this.$router.back()
    },
    nowUpdate () {
      // this.settingWater()
      this.quit = true
      this.$router.back()
    },
    showPopup () {
      this.show = true
    },
    closePopup () {
      this.show = false
    },
    setCellular () {
      this.toast = this.$createToast({
        time: 0,
        txt: ' 正在设置备份Wi-Fi信息',
        mask: true
      }).show()
      if (isLocal === 'local') {
        axios.post('/Calendar/api/device/set/device/cellular_info/', {
          device_id: this.deviceId,
          wifi_name: this.hotName,
          wifi_password: this.hotPass
        })
        .then(this.setCellularSuccess)
        .catch(this.setCellularError)
      } else {
        axios.post(api + '/Calendar/api/device/set/device/cellular_info/', {
          device_id: this.deviceId,
          wifi_name: this.hotName,
          wifi_password: this.hotPass
        })
        .then(this.setCellularSuccess)
        .catch(this.setCellularError)
      }
    },
    setCellularSuccess (res) {
      this.toast.hide()
      // console.log("res.data------>>>>" + JSON.stringify(res.data))
      if (res.data.result === 0) {
        // this.toast = this.$createToast({
        //   txt: '设置成功',
        //   type: 'txt'
        // }).show()
        localStorage.setItem('max_hot_name', this.hotName)
        localStorage.setItem('max_hot_pass', this.hotPass)
        this.showTip = true
      }
    },
    setCellularError (error) {
      console.log(error)
      this.toast.hide()
    },
    getCellular () {
      this.toast = this.$createToast({
        time: 0,
        txt: '正在获取备份Wi-Fi信息',
        mask: true
      }).show()
      if (isLocal === 'local') {
        axios.post('/Calendar/api/device/get/device/cellular_info/', {
          device_id: this.deviceId
        })
        .then(this.getCellularSuccess)
        .catch(this.getCellularError)
      } else {
        axios.post(api + '/Calendar/api/device/get/device/cellular_info/', {
          device_id: this.deviceId
        })
        .then(this.getCellularSuccess)
        .catch(this.getCellularError)
      }
    },
    getCellularSuccess (res) {
      this.toast.hide()
      var _res = res.data
      if (_res.result === 0) {
        this.hotName = _res.info.name
        this.hotPass = _res.info.password
      }
    },
    getCellularError (error) {
      console.log(error)
      this.toast.hide()
    },
    save () {
      if (!this.hotName || !this.hotPass) {
        this.toast = this.$createToast({
          txt: '帐号或者密码不能为空',
          type: 'txt'
        }).show()
        return false
      } else if (this.hotName === localStorage.getItem('max_hot_name') && this.hotPass === localStorage.getItem('max_hot_pass')) {
        this.toast = this.$createToast({
          txt: '修改后保存',
          type: 'txt'
        }).show()
        return false
      }
      this.setCellular()
    }
  },
  mounted () {
    Common.setTitle('配置备份Wi-Fi')
    this.getCellular()
  }
}
</script>
<style lang="stylus" scoped>
@import '~styles/mixins.styl'
.container
  background #ffffff;
  .item
    padding 15px 15px 0
  .titlegn
    font-size 16px
    padding 25px 15px 5px
    color #000000
  .contentgn
    font-size 12px
    padding 5px 15px 0 15px
    color #666666
    line-height 17.5px
  .titlecj
    font-size 16px
    padding 15px 15px 5px 
    color #000000
  .contentcj
    font-size 12px
    padding 5px 15px 0 15px
    color #666666
    line-height 17.5px
  .contentcjs
    font-size 12px
    padding 0 15px 0 15px
    color #666666
    line-height 17.5px
  .titletip
    font-size 12px
    padding 10px 30px 0 30px
    color #EE0B0B
    width 240px
  label
    display block
    font-size 14px
    padding-bottom 10px
  .cube-input
    background-color #efefef
  .bfbtn
    background-color #ffffff
    margin-top 12px
    margin-left 134px 
    font-size 14px
  .btnsave
    background-color #000000
    margin-top 87px
    margin-left 20px
    width 335px
    height 44px
    font-size 16px 
    color #FFFFFF
  .btnknow
    background-color #000000
    margin-top 10px
    margin-left 15px
    width 90%
    height 44px
    font-size 16px 
    color #FFFFFF
    margin-bottom 16px
</style>


// WEBPACK FOOTER //
// src/pages/hotSetting/hotSetting.vue